/** Aligned with backend ApprovalController instance/inbox read endpoints. */
export const APPROVAL_INSTANCE_VIEW_PERMISSIONS = [
  'APPROVAL_VIEW',
  'APPROVAL_ACT',
  'APPROVAL_MANAGE',
  'APPROVAL_DELEGATE',
  'HR_VIEW',
  'HR_ATTENDANCE_MANAGE',
  'HR_LEAVE_MANAGE',
  'HR_APPROVAL_MANAGE',
  'HR_MANAGE',
  'ORG_MANAGE',
] as const;

/** Builder + metadata read — matches route registry view for /{module}/approvals/builder. */
export const APPROVAL_BUILDER_VIEW_PERMISSIONS = [
  'APPROVAL_VIEW',
  'APPROVAL_MANAGE',
  'APPROVAL_ACT',
  'HR_APPROVAL_MANAGE',
  'HR_MANAGE',
  'ORG_MANAGE',
] as const;

/** Approval matrix page read. */
export const APPROVAL_MATRIX_VIEW_PERMISSIONS = [
  'APPROVAL_MATRIX_VIEW',
  'APPROVAL_MANAGE',
  'HR_APPROVAL_MANAGE',
  'ORG_MANAGE',
] as const;

/** Approval inbox / work approvals nav. */
export const APPROVAL_INBOX_VIEW_PERMISSIONS = [
  'APPROVAL_VIEW',
  'APPROVAL_ACT',
  'HR_VIEW',
  'HR_APPROVAL_MANAGE',
  'ORG_MANAGE',
] as const;
